import { BsModalRef } from 'ngx-bootstrap';
import { Component, OnInit, Injector } from '@angular/core';
import { ModalBaseComponent } from '../modal-base-component';
import {DefaultService} from "../../../../gen/swagger-api/api/default.service";
import {AlertService} from "../../../shared/services/alert.service";
import {POOLINFO} from "../../../../gen/swagger-api";

@Component({
  selector: 'app-pool-properties',
  templateUrl: './pool-properties.component.html',
  styleUrls: ['./pool-properties.component.css']
})
export class PoolPropertiesComponent extends ModalBaseComponent implements OnInit {

  constructor(private inject: Injector, private _bsModalRef: BsModalRef,
    private defaultService: DefaultService,
    private alertService: AlertService) { 
      super(inject);
    }

  public pool: POOLINFO;
  public threshold;

  ngOnInit() {
    // this.defaultService.poolsPoolIdWarningThresholdGet(this.pool.id).subscribe(
    //   threshold => this.threshold = threshold
    // );
  }

  public closeModal(): void {
    this._bsModalRef.hide();
  }
  public save(): void {
    // this.defaultService.poolsPoolIdWarningThresholdPost(this.pool.id, this.threshold).subscribe(
    //     response =>{},
    //     error => {
    //       this.alertService.error('error saving threshold');
    //     }
    // );
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/pool-properties/pool-properties.component.ts